export default "__VITE_ASSET__BGLHvUZ___"